export default __webpack_public_path__ + "static/unified-folders-new-af37be90cfa4df83a55da46549160097.webp";